import { render, staticRenderFns } from "./DaysForm.vue?vue&type=template&id=2b98be5e&scoped=true&"
import script from "./DaysForm.vue?vue&type=script&lang=js&"
export * from "./DaysForm.vue?vue&type=script&lang=js&"
import style0 from "./DaysForm.vue?vue&type=style&index=0&id=2b98be5e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b98be5e",
  null
  
)

export default component.exports